import React from 'react';

/** Skeleton placeholders for dashboard stat bento while user data loads. */
export function DashboardSkeleton({ statCount = 4 }) {
  return (
    <div className="pf-consumer-bento mb-8" aria-hidden="true">
      {Array.from({ length: statCount }).map((_, i) => (
        <div key={i} className="pf-organic-card pf-bento-cell animate-pulse">
          <div className="flex items-center gap-4">
            <div className="w-11 h-11 rounded-xl bg-[var(--pf-border)]" />
            <div className="flex-1 space-y-2">
              <div className="h-3 w-24 rounded bg-[var(--pf-border)]" />
              <div className="h-7 w-16 rounded bg-[var(--pf-border)]" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default DashboardSkeleton;
